import { Component, OnInit, Output, EventEmitter, ViewChild, ViewEncapsulation, ElementRef, ChangeDetectorRef, OnDestroy, AfterViewInit, ViewChildren, QueryList, Input } from '@angular/core';
import { animate, state, style, transition, trigger, group } from '@angular/animations';
import { DemoService } from '../../shared/demo.service';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
import { MatTableDataSource } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, MatAutocomplete, MatAutocompleteTrigger, PageEvent, MatPaginator } from '@angular/material';
import { FormControl } from '@angular/forms';
import { VquadbtfxoComponent } from 'src/app/statistics/network-status/vquadbtfxo/vquadbtfxo.component';
import { CommonFilter } from 'src/app/shared/models/Common/common-filter';
import { parse } from 'querystring';
import { NWSTAT_VQUAD } from 'src/app/shared/models/NWSTAT_VQUAD';
import { NWSTAT_VQUAD_CENTRALIPS } from 'src/app/shared/models/NWSTAT_VQUAD_CENTRALIPS';
import { SelectionModel } from '@angular/cdk/collections';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
import { Chart, ChartType, ChartOptions } from 'chart.js';
import { ChartsModule } from 'ng2-charts';
import { strictEqual } from 'assert';
import { E } from '@angular/cdk/keycodes';
import { Router, ActivatedRoute } from '@angular/router';
import { SelectItem, Keys } from 'lib/common';
import { rsltTypeInTitle } from 'src/app/shared/functions/title';
import { Job } from 'src/app/shared/models/Scheduler/Job';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';
import XLSXStyle from 'xlsx-style';
//https://www.ngdevelop.tech/export-to-excel-in-angular-6/
import { Workbook, stream } from 'exceljs';
//import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as moment from 'moment';
import { url } from 'inspector';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { formatDate, lastDateFunc, formatDBTZDateToLocalDate, getDateValue, getDateValueViaValue } from 'lib/common/utils';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { DataFilter } from 'lib/ng-data-table/base';
import { CustomreportlinechartComponent } from '../customreportlinechart/customreportlinechart.component';
//File-Saver for downloading PDF - IMP
declare var require: any
const FileSaver = require('file-saver');

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-custom-report',
  templateUrl: './custom-report.component.html',
  styleUrls: ['./custom-report.component.scss']
})
export class CustomReportComponent implements OnInit, AfterViewInit, OnDestroy {
  clearAllFiltersAction: boolean = true;
  actionsMessage: string = 'Actions';
  modifyFiltersMessage: string = 'Modify filters';
  clearFiltersMessage: string = 'Clear all filters';
  isFilters: boolean = true;
  hasFilters: boolean;

  //susheel 
  rsltType: string = "custom-reports";
  rsltTypeTS = '-1';
  TSSelected: number;
  AutoRefreshInfo: any;
  title: string = "Custom Reports";
  staticScreen = false;
  @Output() childTitleEvent = new EventEmitter();

  baseUrl: string;
  url: string;
  isLoading = false;
  noRecordFound = false;
  selectedFilter: string = "Aggregate";
  timeFilter: string = "10min";
  timestampSearch: string = "VQUAD_TIMESTAMP";
  reportID: number = 0;
  isCustomDate: boolean = false;
  startDate: Date;
  endDate: Date;
  RecordPerPage: string = "200";
  chartID: string = "chartID";
  groupReportID: number = 0;
  crFilterType: string = "";
  isBarChart: boolean = false;
  isLineChart: boolean = false;
  filterType_LineGraph: string = "";
  selectedReportName: string = "";
  selectedGroupName: string = "";
  isRefreshClicked: boolean = false;
  firstTimeFunctionCall: boolean = false;
  restorePreviousReportID: number = 0;
  restoreGroupID: number = 0;

  reportList = [];
  dataSource = [];
  exportDataSource: any[];
  tableDef: Array<any> = [];
  columnsToDisplay: string[];
  groupReportATMainList = [];
  groupReportList: SelectItem[] = [];
  grpCRNamesObservable: SelectItem[] = [];
  groupReportATList: SelectItem[] = [];
  customReportList: SelectItem[] = [];
  CRNamesObservable: SelectItem[] = [];
  selectedGroupID: number[] = [0];
  selectedGroupATID: number[] = [0];
  selectedReportID: number[] = [0];
  modelGrpCRName: string;
  selectedtimeFilter: string[] = ['10min'];
  selectedtimestampSearch: string[] = ['VQUAD_TIMESTAMP'];
  selectedRecordPerPage: string[] = ['200'];
  selectedStartEndTime: any;

  // MatPaginator Inputs
  TotalRecordCount:number = 0;
  currentPage: number;
  length = 0;
  pageSize = this.RecordPerPage;
  pageSizeOptions: number[] = [1, 10, 25, 100];
  pageIndex = 0;
  ResulTypeLatestID_CRPagination = "";

  pageEvent: PageEvent;  // MatPaginator Output
  private commonFilter: CommonFilter;
  barChart = null;
  barChart1: Chart;
  lineChart = null;
  lineChartTest: Chart;
  dummyBarChart = null;
  mlineChart: Chart[] = [];
  lineChartCount: any;
  lineChartData: any;

  interval;

  @ViewChild("stackchartcanvas", { static: true }) stackchartcanvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('exporter', { static: true }) exporter: ElementRef;
  @ViewChild('pdfReport', { static: false }) pdfReport: ElementRef;
  @ViewChild('linechartReport', { static: false }) linechartReport: ElementRef;
  @ViewChild('dateInput', { static: true }) dateInput: ElementRef;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  MainFilterID = 0;
  MainFilterTZ = 0;
  genArrDel = [];
  genArr = [];
  private dataFilter: DataFilter;
  private subscriptions: Subscription[] = [];
  filterEventIDSelected = false;
  delColSelected = false;

  toHighlightCR: string = '';
  toHighlightGrpCR: string = '';

  constructor(private _Activatedroute: ActivatedRoute, private _router: Router, private http: HttpClient, private service: DemoService, public datepipe: DatePipe, private commonFilterService: CommonFilterService, private dialog: MatDialog, private cdr: ChangeDetectorRef) {
    this.baseUrl = environment.urlAddress + '/api/';
    this.firstTimeFunctionCall = true;
    this.dataFilter = new DataFilter();
    this.commonFilterService.setNonFiltersScreen(this.staticScreen);

    this.commonFilterService.mainFilterID.subscribe(res => this.MainFilterID = res);// set mainfilter ID
    this.commonFilterService.mfTZ.subscribe(res => this.MainFilterTZ = res);// set mainfilter ID
    //console.log("MainFilterTZ");
    //console.log(this.MainFilterTZ);
    this.lineChartCount = Array(0).fill(0).map((x, i) => i);
    //this.lineChartCount.push(1);
    //this.lineChartCount.push(2);
    //this.lineChartCount.push(3);

    _Activatedroute.params.subscribe(val => {
      this.rsltType = _Activatedroute.snapshot.url[1].path;
      this.parentEvent();
    });

    this.commonFilterService.TSType.subscribe(res => {
      this.commonFilter = new CommonFilter();
      this.SetTimestampSearch(res);
    });//TsType


    //NOT NEEDED AS Refresh already is taking care
    //const _broadSubCRRefresh = this.commonFilterService.componentCRMethodCalled$.subscribe(res => {
    //  //this.selectedFilters = 0;
    //  //this.constructorLoad = true;
    //  this.LoadReportByFilterMethod(this.selectedFilter, true);
    //});
    //this.subscriptions.push(_broadSubCRRefresh);

    const _broadSublisten = this.commonFilterService.listen.subscribe(res => {
      if (res === 'onlyCRInit' && !this.filterEventIDSelected)
        this.UpdateScreen();
      if (this.filterEventIDSelected)
        this.filterEventIDSelected = false;
    });
    this.subscriptions.push(_broadSublisten);

    this.commonFilterService.isFilters$.subscribe(res => {
      this.isFilters = res;
    });

    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log('')
        //debugger;
        ///this is implemented when click on refresh after any change made in config sceen for the selected report.
        ///cpz if in config screen selected report is edited and saved then in database it will delete existing one and save it as new record so report id is mismatched. so to avoid that local storage is used to store report name instead of ID.
        this.isRefreshClicked = false;
        if (localStorage.getItem('selectedReportName') != null) {
          this.selectedReportName = localStorage.getItem('selectedReportName');
          this.isRefreshClicked = true;
        }
        if (localStorage.getItem('selectedGroupID') != null) {
          this.restoreGroupID = Number(localStorage.getItem('selectedGroupID'));
          this.isRefreshClicked = true;
        }

        //console.log(this.restoreGroupID)
        if (this.selectedFilter != "Group")
          this.LoadReportByFilterMethod(this.selectedFilter, true);
        else
          this.LoadGroupBasedData();


      }
    );
    this.subscriptions.push(_broadSubRefresh);

    //Do Refresh
    const _broadSubRefreshByEdit = this.commonFilterService.componentCRMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.commonFilterService.basicCRSavedRefresh('');
        //console.log(res)
        this.isRefreshClicked = false;
        if (localStorage.getItem('selectedReportName') != null) {
          this.selectedReportName = localStorage.getItem('selectedReportName');
          this.isRefreshClicked = true;
        }
        //if (localStorage.getItem('selectedGroupID') != null) {
        //  this.restoreGroupID = Number(localStorage.getItem('selectedGroupID'));
        //  this.isRefreshClicked = true;
        //}
        if (localStorage.getItem('selectedGroupName') != null) {
          this.selectedGroupName = localStorage.getItem('selectedGroupName');
          this.GetReportListByGrpName(this.selectedGroupName);
          this.isRefreshClicked = true;
        }


        if (this.selectedFilter != "Group")
          this.LoadReportByFilterMethod(this.selectedFilter, true);
        else
          this.LoadGroupBasedData();


      }
    );
    this.subscriptions.push(_broadSubRefreshByEdit);
    

    //https://stackoverflow.com/questions/57909492/does-the-subscribe-function-execute-synchronously
    //return this.commonFilterService.AllGeneralFilter.pipe(map(res => {
    //https://stackoverflow.com/questions/53741079/filter-with-json-in-angular-6
    const _broadSubAllGeneralFilter = this.commonFilterService.AllGeneralFilter.subscribe(res => {
      this.AllGeneralFilter = res;
      if (!this.delColSelected && !this.clearAllFiltersBool && this.AllGeneralFilter.length > 0)
        this.UpdateScreen();
      //reset here
      if (this.delColSelected)
        this.delColSelected = false;
      if (this.clearAllFiltersBool)
        this.clearAllFiltersBool = false;

      this.delFilterColName = '';//reset if delete or clear all filters
    });
    this.subscriptions.push(_broadSubAllGeneralFilter);

    //https://medium.com/cp-massive-programming/angular-user-inheritance-to-unsubscribe-from-observables-f5617fbbd8f2
    //https://stackoverflow.com/questions/42951400/angular-2-behaviorsubject-avoid-with-multiple-subscription
    const _broadSubDeleteFilter = this.commonFilterService.DeleteFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        if (res !== '') {//IMP IMP
          this.delFilterColName = res;
          this.UpdateScreen();
        }
      }
    );
    this.subscriptions.push(_broadSubDeleteFilter);

    //const _broadSubGeneralDFFilter = this.commonFilterService.GeneralFilterDF.subscribe(res => {
    //  //console.log('GeneralDFFilter')
    //  this.filters = res;
    //});
    //this.subscriptions.push(_broadSubGeneralDFFilter);
    const _broadSubGeneralFilter = this.commonFilterService.GeneralFilter.subscribe(res => {
      //console.log('GeneralFilter')
      //console.log(res)
      this.filters = res;
    });
    this.subscriptions.push(_broadSubGeneralFilter);

    const _broadSubEventIDFilter = this.commonFilterService.GeneralEventIDFilter.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        //console.log('filtersWithEventID')
        //this.filterEventIDSelected = true;
        this.filtersWithEventID = res;
        //if (!this.delColSelected && !this.clearAllFiltersBool && (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0))
        //  this.UpdateScreen();
      });
    this.subscriptions.push(_broadSubEventIDFilter);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(this.AutoRefreshInfo);

        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);
            this.UpdateScreen();
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);

  }
  @ViewChildren(MatAutocompleteTrigger) triggerCollection: QueryList<MatAutocompleteTrigger>;
  @ViewChild('inputCR', { static: false }) inputCtrl;
  @ViewChild('inputGrpCR', { static: false }) inputGrpCtrl;

  controlCR = new FormControl();

  @Input() myConfigNameCR = "null";

  controlGrpCR = new FormControl();

  @Input() myConfigNameGrpCR = "null";

  parentEvent() {
    //debugger;
    this.title = rsltTypeInTitle(this.rsltType);
    this.childTitleEvent.emit(this.title);
  }

  initCR = false;
  initGrpCR = false;
  ngOnInit() {
    this.initCR = true;
    if (this.myConfigNameCR == "")
      this.myConfigNameCR = "null";
    this.initGrpCR = true;
    if (this.myConfigNameGrpCR == "")
      this.myConfigNameGrpCR = "null";

    //this.BindBarChartTest();
    //this.BindLineChart();

    //this.BindMultiLineChartTest();
    // this.BindBarChartSample();
  }

  ngAfterViewInit() {

    if (this.myConfigNameCR != "null") {
      this.isLoading = true;
      this.interval = setInterval(() => {
        this.triggerCollection.forEach((x, i) => {
          if (i == 0) {
            const selMatOption = x.autocomplete.options.toArray();
            if (selMatOption.length > 0) {
              this.controlCR.setValue({ name: selMatOption.find((o) => o.value.name === this.myConfigNameCR).value });
              clearInterval(this.interval);
            }
          }
        });
      }, 1000);
      this.isLoading = false;
    }

    if (this.myConfigNameGrpCR != "null") {
      this.isLoading = true;
      this.interval = setInterval(() => {
        this.triggerCollection.forEach((x, i) => {
          if (i == 0) {
            const selMatOption = x.autocomplete.options.toArray();
            if (selMatOption.length > 0) {
              this.controlGrpCR.setValue({ name: selMatOption.find((o) => o.value.name === this.myConfigNameGrpCR).value });
              clearInterval(this.interval);
            }
          }
        });
      }, 1000);
      this.isLoading = false;
    }

    //////////// to restore previous reports
    if (this.firstTimeFunctionCall) {
      this.RestorePreviousDispalyOptions();
    }

    //this.hasFilters = this.table.dataFilter.hasFilters();
    this.selectedStartEndTime = { startDate: moment(), endDate: moment().add(1, 'days') };
    this.dataSource = [];
    this.LoadReportByFilterMethod(this.selectedFilter);

    this.controlCR.valueChanges.subscribe(newValue => {
      this.CRNamesObservable = this._CRName(newValue);
    })

    this.controlGrpCR.valueChanges.subscribe(newValue => {
      this.grpCRNamesObservable = this._GrpCRName(newValue);
    })



  }

  RestorePreviousDispalyOptions() {
    //this.firstTimeFunctionCall = false;
    const selectedcustomreportID = this.commonFilterService.customReportID_Config.subscribe(res => {
      if (this.firstTimeFunctionCall && res != null && res != 0) {
        if (!res.toString().includes('Group')) {
          let value = res.toString();
          //this.isPreSelectedReportId_Mainscreen = true;
          //this.selectedReportID_MainScreen = Number(value.split('@')[0]);
          //this.selectedMethodOfFilter_MainScreen = value.split('@')[1];
          this.selectedFilter = value.split('@')[1];
          this.restorePreviousReportID = Number(value.split('@')[0]);

        }
        else {
          let value = res.toString();
          this.selectedFilter = value.split('@')[1];
          this.restorePreviousReportID = Number(value.split('@')[0]);
          this.LoadGroupBasedData();
        }

      }
    });
    //this.cdr.detectChanges();
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.triggerCollection.forEach((x, i) => {
        x.closePanel();
      });
    }, 1000);
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  parentRef(TSSelected) {
    this.TSSelected = parseInt(TSSelected);
  }
  parentEventID() {
    this.UpdateScreen();
  }
  parentAutoRef(AutoRefreshInfo) {
    this.TSSelected = parseInt(AutoRefreshInfo.TSSelected);
    this.AutoRefreshInfo = AutoRefreshInfo;
  }

  modifyFilter() {
    //this._router.navigate([{ outlets: { filterPopup: ['filters'], configPopup: null } }]);
    let selectedMainFilterCrieriaName = 'null';
    this.commonFilterService.mainFilter_CriteriaName.subscribe(res => selectedMainFilterCrieriaName = res);
    this._router.navigate([{ outlets: { filterPopup: ['filters', selectedMainFilterCrieriaName], configPopup: null } }]);

    /////// when calling modify search set mainfilter to initial values
    //this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
    //this.commonFilterService.setMFCustDT("");
    //this.commonFilterService.setMFTZON(0);
    ////this.commonFilterService.basicRefresh();
  }

  clearAllFiltersBool = false;
  clearAllFilters() {

    //debugger;
    this.delFilterColName = 'clearAllFilters';
    //this.hasFilters = false;
    this.UpdateScreen();
    //this.table.sorter.sortMeta = [];
    //this.table.events.onSort();//IMP- to reset sorting sel cols to none

    //if (this.table.dataFilter.hasFilters()) {
    //  this.table.dataFilter.clear();
    //  //console.log(this.table.dataFilter.hasFilters())
    //  this.table.events.onFilter();
    //  //this.table.events.onFilterClear();
    //  this.clearFilters.emit();
    //}
  }


  async LoadCustomReport(selectedReportID, group = false, event?: PageEvent) {

    this.isLoading = true;
    this.dataSource = [];
    this.tableDef = [];
    this.columnsToDisplay = [];

    await this.SetCustomFilters();//// to set time filter and timestampSearch from global filter box

    //let reportName = "GLVQTTesting_1";  //this.reportList.find(m => m.ID_Abs == selectedReportID).CriteriaName_Abs;
    let found = this.reportList.find(m => m.ID_Abs == selectedReportID);
    let critName = "";
    if (found)
      critName = found.CriteriaName_Abs;
    let reportName = group == false ? critName : selectedReportID;
    this.selectedReportName = reportName;
    this.controlCR.setValue({ name: reportName });
    localStorage.setItem('selectedReportName', reportName);

    debugger;
    this.commonFilter = new CommonFilter();
    //sart pagination
    this.commonFilter.ResulTypeLatestID_CRPagination = this.ResulTypeLatestID_CRPagination;
    this.pageSize = this.selectedRecordPerPage.toString();
    let isPaginationApplied = false;
    if (event != undefined) {
      isPaginationApplied = true;
      this.currentPage = +event.pageIndex + +1;
      this.commonFilter.PerPage = this.selectedRecordPerPage.toString();//event.pageSize.toString();
      this.commonFilter.PageNumber = this.currentPage.toString();

    } else {
      isPaginationApplied = false;
      this.commonFilter.PerPage = this.selectedRecordPerPage.toString(); //this.pageSize.toString();
      this.commonFilter.PageNumber = "1";
      this.pageIndex = 0;

      this.paginator.pageIndex = 0;
      //this.currentPage = 1;

    }
    //end pagination
    this.commonFilter.MainFilterID = this.MainFilterID;
    //////check if loggedIn user has any criteria for filtering data
    if (sessionStorage.getItem('SystemSettings') != null)
      this.commonFilter.UserCriteria = JSON.parse(sessionStorage.getItem('SystemSettings')).Criteria;

    let startDate = "";
    let endDate = "";

    if (this.timeFilter == "Custom") {
      //startDate = this.selectedStartEndTime.startDate.format('MM/DD/YYYY HH:mm:ss'); 
      //endDate = this.selectedStartEndTime.endDate.format('MM/DD/YYYY HH:mm:ss'); 
      startDate = this.selectedStartEndTime.startDate;
      endDate = this.selectedStartEndTime.endDate;
    }

    let grpTypeForTZ = false;
    if (this.selectedFilter.trim() == "Aggregate")
      this.url = this.baseUrl + 'CustomReps/GetCustomReportGroupMainScreenData?reportName=' + reportName + '&timeFilter=' + this.timeFilter + '&timestampSearch=' + this.timestampSearch + '&startDate=' + startDate + '&endDate=' + endDate;
    else if (this.selectedFilter == "Timestamp") {
      grpTypeForTZ = true;
      this.url = this.baseUrl + 'CustomReps/GetCustomReportNGpMainScreenData?reportName=' + reportName + '&timeFilter=' + this.timeFilter + '&timestampSearch=' + this.timestampSearch + '&startDate=' + startDate + '&endDate=' + endDate + '&totalRecordCount=' + this.TotalRecordCount + '&isPaginationApplied=' + isPaginationApplied;
    }
    else {
      if (this.crFilterType.trim() == "Aggregate")
        this.url = this.baseUrl + 'CustomReps/GetCustomReportGroupMainScreenData?reportName=' + reportName + '&timeFilter=' + this.timeFilter + '&timestampSearch=' + this.timestampSearch + '&startDate=' + startDate + '&endDate=' + endDate;
      else {
        grpTypeForTZ = true;
        this.url = this.baseUrl + 'CustomReps/GetCustomReportNGpMainScreenData?reportName=' + reportName + '&timeFilter=' + this.timeFilter + '&timestampSearch=' + this.timestampSearch + '&startDate=' + startDate + '&endDate=' + endDate + '&totalRecordCount=' + this.TotalRecordCount + '&isPaginationApplied=' + isPaginationApplied;
      }
    }
    //console.log(this.genArr)
    //debugger;

    
    let body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.genArr });
    await this.GetCustomReport_Service(body).toPromise().then((res: any) => {
      let rows: any[] = JSON.parse(res) as any[];
      //debugger;
      if (rows != null) {
        this.noRecordFound = false;
        if (this.barChart != null)
          this.barChart.destroy();
        if (this.mlineChart != null) {
          //this.lineChart.destroy();
          //this.mlineChart.forEach(chart => chart.destroy());


          //let canvasID = 0;
          //this.mlineChart.forEach(chart => {
          //  chart.destroy(); // Destroy the chart
          //  const canvas = chart.canvas; // Get the canvas element
          //  // Get the canvas element by its ID
          //  const canvasElement = document.getElementById(canvasID.toString());
          //  if (canvasElement) {
          //    // Remove the canvas element from the DOM
          //    canvasElement.remove();
          //    canvasID++;
          //  }

          //});

          //this.mlineChart = [];

        }

        this.tableDef = rows["ColumnHeader"];
        this.columnsToDisplay = rows["DisplayColumn"];
        //console.log(rows["ResulTypeLatestID_CRPagination"]);
        this.ResulTypeLatestID_CRPagination = rows["ResulTypeLatestID_CRPagination"];

        this.dataSource = rows["ColumnData"];
        //this.exportDataSource = rows["ColumnData"];
        if (grpTypeForTZ == true) {
          //"ColumnData":[{"VQuad_Timestamp":"24-11-2022 18:41:19","Call_Timestamp":"24-11-2022 18:39:43"}]

          let timeFormat = 'HH:mm:ss';

          //console.log(this.datepipe.transform(new Date(formatDBTZDateToLocalDate('11-25-2022 13:14:15', dbTz, dbAndBrHrs, this.MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat))
          Object.keys(this.dataSource).forEach(key => {
            if (key) {
              if (this.dataSource[key].VQuad_Timestamp != null)
                this.dataSource[key].VQuad_Timestamp = this.datepipe.transform(new Date(formatDBTZDateToLocalDate(getDateValue(this.dataSource[key], "VQuad_Timestamp", ' '), this.dbTz, this.dbAndBrHrs, this.MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat);
              if (this.dataSource[key].Call_Timestamp != null)
                this.dataSource[key].Call_Timestamp = this.datepipe.transform(new Date(formatDBTZDateToLocalDate(getDateValue(this.dataSource[key], "Call_Timestamp", ' '), this.dbTz, this.dbAndBrHrs, this.MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat);
            }
          });
          //console.log(this.dataSource)
        }

        this.isBarChart = true;
        this.cdr.detectChanges();/////this is done so that isBarChart div should be included in document immediately before calling this.BindBarChart() else it will be null and barchart wont be binded
        this.exportDataSource = this.dataSource;

        //////to bind linechart only if pagination is not apllied for performance purpose
        if (!isPaginationApplied) {
          this.BindLineChart(rows); //bind line chart
        }
        else {
          this.isLineChart = true;
        }

        this.BindBarChart(rows, reportName);  //bind bar chart

        //this.BindLineChart(rows); //bind line chart

        this.length = rows["TotalRecordCount"];
        this.TotalRecordCount = rows["TotalRecordCount"];

        this.isLoading = false;
      }
      else {
        this.isLoading = false;
        //this.isBarChart = false;
        //this.isLineChart = false;
        this.noRecordFound = true;
      }
    },
      error => {
        console.log('httperr', error); this.isLoading = false;
        //this.isBarChart = false;
        this.isLineChart = false;
        this.noRecordFound = true;
      });
  }

  LoadColumnData() {

    this.url = this.baseUrl + 'CustomReps/GetColumnData';
    //console.log(this.genArr)
    let body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.genArr });
    this.GetCustomReport_Service(body).subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];

      this.dataSource = rows;

    },
      error => { console.log('httperr', error); });
  }

  setCommonFilters() {
    //debugger;
    if (this.dateInput !== undefined) {
      let inputValue = this.dateInput.nativeElement.value;
      if (inputValue.length == 0)//Default/Last selected setting when page loaded / changed to different page
      {


        if (inputValue == "Custom range") {
          //this.commonFilterService.TSBetween.subscribe(res => {
          //  //https://stackoverflow.com/questions/38251763/moment-js-how-to-convert-date-string-into-date
          // this.selectedTime.startDate = moment(new Date(res.split('^')[0]));
          // this.selectedTime.endDate = moment(new Date(res.split('^')[1]));
          //  startAndEndDates = this.selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + ' - ' + this.selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');
          //});
        }
      }
    }
  }

  /////////////////////////////////////Start EXPORT FILE
  ExportReport(exportType) {
    let reportName = this.selectedReportID[0] > 0 ? this.reportList.find(m => m.ID_Abs == this.selectedReportID[0]).CriteriaName_Abs : this.groupReportList.find(m => m.id == this.selectedGroupID[0]).name;
    if (exportType == "EXCEL")
      this.GetExportData(exportType);//this.exporter.exportTable('xlsx', { fileName: reportName });
    else if (exportType == "CSV")
      this.GetExportData(exportType);
    //this.ExportCSV();//this.exporter.exportTable('csv', { fileName: reportName });
    //else if (exportType == "TXT")
    //  this.exporter.exportTable('txt', { fileName: reportName });

  }

  public ExportReportToPDF1() {
    //debugger;
    //const doc = new jsPDF('l', 'mm', "a4");
    const pdf = new jsPDF();

    const specialElementHandlers = {
      '#editor': function (element, renderer) {
        return true;
      }
    };

    const content = this.pdfReport.nativeElement;
    //const lineChart = this.linechartReport.nativeElement;

    pdf.fromHTML(content.innerHTML, 15, 15, {
      width: 190,
      'elementHandlers': specialElementHandlers
    });

    ///start chart
    pdf.addPage();
    pdf.addImage(this.barChart.toBase64Image(), 'PNG', 0, 0);
    //pdf.addPage();

    //pdf.addImage(this.barChart1.toBase64Image(), 'PNG', 0,0);
    pdf.addPage();
    //doc.addImage(this.linechartReport, 'PNG', 0, 0);

    var data = this.linechartReport.nativeElement;//document.getElementById('contentToConvert');

    html2canvas(data).then(canvas => {
      // Few necessary setting options  
      var imgWidth = 208;
      var pageHeight = 295;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      var heightLeft = imgHeight;


      const contentDataURL = canvas.toDataURL('image/png')

      //let pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF  
      var position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)

      pdf.save('MYPdf.pdf'); // Generated PDF   
    });


    ///end chart

    //doc.save('test.pdf');

  }

  public ExportReportToPDF_Test() {
    const fileName = "z_all_202205311738" + ".pdf"; // z_polqa1_202107161511   z_all_202205311738
    // const fileUrl = '/assets/DownloadedReports/' + fileName;
    //const fileUrl = 'http://localhost:8050/CustomReports/' + fileName;  /// For local
    const fileUrl = 'http://localhost/CustomReports/' + fileName;  //// For Test Server

    FileSaver.saveAs(fileUrl, fileName);
  }
  public ExportReportToPDF() {
    this.isLoading = true;
    //this.url = "http://localhost:53316/QueueJobs.aspx/saveArrFromWebview1";  ////"http://localhost/WebviewerScheduler/QueueJobs.aspx/saveArrFromWebview1"; // the method we are calling to save Array to DB localhost:50316 / localhost/WebviewerScheduler
    this.url = "http://localhost/WebviewerScheduler/QueueJobs.aspx/saveArrFromWebview1"; //// test server
    this.ExportReportToPDF_Service().subscribe((res: any) => {
      //debugger;
      this.isLoading = false;
      //alert(res.d);
      const fileName = res.d.toString();//+".pdf";
      let basedownloadURL = document.getElementsByTagName('base')[0].href.replace('/Webviewer/', ''); ///test server
      //const fileUrl = '/assets/DownloadedReports/' + fileName;
      // const fileUrl = 'http://localhost:8050/CustomReports/' + fileName;  /// For local
      //const fileUrl = 'http://localhost/WebviewerScheduler/CustomReports/' + fileName;  //// remote pc of Test Server
      const fileUrl = basedownloadURL + '/WebviewerScheduler/CustomReports/' + fileName;  //// with ip address of Test Server


      //this.http.get(fileUrl, {
      //  responseType: "blob",
      //  headers: new HttpHeaders().append("Content-Type", "application/json")
      //}).subscribe(resp => {
      //  //Resp: file stream
      //  const blob = new Blob([resp], { type: 'application/pdf' });
      FileSaver.saveAs(fileUrl, fileName);
      //})



      ////////const a = document.createElement('a');
      ////////a.setAttribute('style', 'display:none;');
      ////////document.body.appendChild(a);
      ////////a.download = fileName;
      ////////a.href = fileUrl;//URL.createObjectURL(downloadedFile);
      ////////a.target = '_blank';
      ////////a.click();
      ////////document.body.removeChild(a);

      //this.service.DownloadPDF(fileName);

    },
      error => {
        //https://stackoverflow.com/questions/46019771/catching-errors-in-angular-httpclient/46019852
        console.log('httperr', error);
        this.isLoading = false;
      });

    //this.ExportReportToPDF_Service();
  }

  pdfTest() {
    const fileName = "GLVQTTesting_1_202107121127" + ".pdf"; //'1.pdf';
    const fileUrl = '/assets/DownloadedReports/' + fileName;


    //window.open(fileUrl);

    //var a = document.createElement('a');
    //a.href = fileUrl;
    //a.target = '_blank';
    //a.download = 'bill.pdf';
    //document.body.appendChild(a);
    //a.click();

    FileSaver.saveAs(fileUrl, fileName);
  }

  public ExportExcel() {
    //debugger;
    var datat = [
      { "nameasddsddssdsa": "John", "city": "Seattle" },
      { "nameasddsddssdsa": "Mike", "city": "Los Angeles" },
      { "nameasddsddssdsa": "Zach", "city": "New York" }
    ];
    var options = {
      cellStyles: true
    }


    const workBook = XLSX.utils.book_new(); // create a new blank book

    //const workSheet = XLSX.utils.json_to_sheet(this.exportDataSource);/// 1st sheet    
    //XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book

    const workSheet1 = XLSX.utils.json_to_sheet(datat);////2nd sheet
    // workSheet1[XLSX.utils.encode_cell({ c: 1, r: 1 })] = cell;
    //workSheet1["!cols"] = [{
    //  wpx: 470
    //}, {
    //  wpx: 70
    //}, {
    //  wpx: 70
    //}, {
    //  wpx: 70
    //}, {
    //  wpx: 150
    //}, {
    //  wpx: 120
    //}]; //Cell Column Width

    //workSheet1["A1"].s = { font: { sz: 14, bold: true, color: { rgb: "FFFFAA00" } }, fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "FFFF00" } }, border: { top: { style: 'medium', color: { rgb: "FFFFAA00" } }, left: { style: 'medium', color: { rgb: "FFFFAA00" } } } };

    XLSX.utils.book_append_sheet(workBook, workSheet1, 'data1'); // add the worksheet to the book

    XLSX.writeFile(workBook, 'temp.xlsx'); // initiate a file download in browser
  }

  ExportToExcel_ExcelJSLib(rows: any, reportName) {

    var json_data = [{
      "name": "Raja",
      "age": 20,
      cit: "abc"
    },
    {
      "name": "Mano",
      "age": 40,
      "city": "abc"
    },
    {
      "name": "Tom",
      "age": 40,
      "city": "abc"
    },
    {
      "name": "Devi",
      "age": 40,
      "city": "abc"
    },
    {
      "name": "Mango",
      "age": 40,
      "city": "abc"
    }
    ];

    //this.tableDef = rows["ColumnHeader"];
    //this.columnsToDisplay = rows["DisplayColumn"];
    //this.exportDataSource = rows["ColumnData"];

    //create new excel work book
    let workbook = new Workbook();
    debugger;
    for (let i = 0; i < rows.length; i++) {

      let sheetName = reportName;
      if (this.selectedFilter == "Group") {
        sheetName = this.groupReportATMainList[i].Name;
      }
      sheetName = sheetName + "_" + (i + 1).toString(); ///to avoid duplicate sheet name.
      //add name to sheet
      let worksheet = workbook.addWorksheet(sheetName);
      //add column name
      let header = rows[i].DisplayColumn; //["Namejnnkjnjnjknj", "Agejhkjhjh","Arealkoiommh"]
      let headerRow = worksheet.addRow(header);
      //debugger;
      ////// assign data to each cell
      for (let x1 of rows[i].ColumnData) {
        let x2 = Object.keys(x1);
        let temp = []
        for (let y of x2) {
          temp.push(x1[y])
        }
        worksheet.addRow(temp)
      }

      //first row bgcolor
      worksheet.getRow(1).fill = { type: 'pattern', pattern: 'darkTrellis', fgColor: { argb: 'FFFFFF' }, bgColor: { argb: '0000FF' } };

      ///// set width of column autosize
      worksheet.columns.forEach(function (column, i) {
        var maxLength = 0;
        column["eachCell"]({ includeEmpty: true }, function (cell) {
          var columnLength = cell.value ? cell.value.toString().length : 10;
          if (columnLength > maxLength) {
            maxLength = columnLength + 2;
          }

        });
        column.width = maxLength < 10 ? 10 : maxLength;

      });
    }

    //set downloadable file name
    let fname = reportName;
    let dt = new Date();
    let datetimestamp = "_" + dt.getDate() + dt.getMonth() + dt.getFullYear();

    //add data and file name and download   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, fname + datetimestamp + '.xlsx');
    });


  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    //console.log(buffer);
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  public ExportCSV(data, reportName) {
    //debugger;
    //let rpName = this.selectedFilter != "Group" ? this.reportList.find(m => m.ID_Abs == this.selectedReportID[0]).CriteriaName_Abs : this.groupReportList.find(m => m.id == this.selectedGroupID[0]).name;
    //let dt = new Date();
    //let datetimestamp ="_"+ dt.getDate() + dt.getMonth() + dt.getFullYear();
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data[0].ColumnData);//this.exportDataSource);
    XLSX.utils.book_append_sheet(wb, ws, '');
    //XLSX.writeFile(wb, 'QueryData.csv');
    XLSX.writeFile(wb, reportName + '.csv');
  }

  GetFormatedTimesstampSearch(tsSearch) {
    //'VQUAD_TIMESTAMP
    //'CALL_TIMESTAMP'
    //'DCOSS_TIMESTAMP
    //'VQT_Timestamp',
    if (tsSearch == "VQUAD_TIMESTAMP")
      return "VQuad_Timestamp";
    else if (tsSearch == "CALL_TIMESTAMP")
      return "Call_TimeStamp";
    else if (tsSearch == "DCOSS_TIMESTAMP")
      return "DCOSS_TimeStamp";
    else
      return "VQT_TimeStamp";
  }

  GetExportData(exportType) {
    //debugger;
    this.isLoading = true;


    let reportName = this.selectedFilter != "Group" ? this.reportList.find(m => m.ID_Abs == this.selectedReportID[0]).CriteriaName_Abs : this.groupReportList.find(m => m.id == this.selectedGroupID[0]).name;

    //let reportName = this.selectedFilter == "Group" ? this.reportList.find(m => m.ID_Abs == selectedReportID).CriteriaName_Abs : selectedReportID;

    //debugger;
    this.commonFilter = new CommonFilter();
    ////sart pagination
    //if (event != undefined) {

    //  this.currentPage = +event.pageIndex + +1;
    //  this.commonFilter.PerPage = event.pageSize.toString();
    //  this.commonFilter.PageNumber = this.currentPage.toString();

    //} else {
    //  this.commonFilter.PerPage = this.selectedRecordPerPage.toString(); //this.pageSize.toString();
    //  this.commonFilter.PageNumber = "1";
    //}
    //end pagination
    let startDate = "";
    let endDate = "";

    if (this.timeFilter == "Custom") {
      startDate = this.selectedStartEndTime.startDate;//.format('MM/DD/YYYY HH:mm:ss'); //this.startDate.toDateString();
      endDate = this.selectedStartEndTime.endDate;//.format('MM/DD/YYYY HH:mm:ss'); //this.endDate.toDateString();
    }
    this.commonFilter.MainFilterID = this.MainFilterID;
    //////check if loggedIn user has any criteria for filtering data
    if (sessionStorage.getItem('SystemSettings') != null)
      this.commonFilter.UserCriteria = JSON.parse(sessionStorage.getItem('SystemSettings')).Criteria;

    this.url = this.baseUrl + 'CustomReps/GetExportCustomReport?reportName=' + reportName + '&timeFilter=' + this.timeFilter + '&timestampSearch=' + this.timestampSearch + '&filterMethod=' + this.selectedFilter + '&startDate=' + startDate + '&endDate=' + endDate;
    //console.log(this.genArr)
    let body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.genArr });
    this.GetCustomReport_Service(body).subscribe((res: any) => {

      let rows: any[] = JSON.parse(res) as any[];
      //debugger;
      if (rows != null) {

        //this.tableDef = rows["ColumnHeader"];
        //this.columnsToDisplay = rows["DisplayColumn"];

        //this.exportDataSource = rows["ColumnData"];
        if (exportType == 'CSV')
          this.ExportCSV(rows, reportName);
        else
          this.ExportToExcel_ExcelJSLib(rows, reportName);
        this.isLoading = false;
      }
      else {
        this.isLoading = false;

      }
    },
      error => { console.log('httperr', error); this.isLoading = false; });
  }

  //////to take screenshot of bar/line graph by passing the respective div id
  //captureScreenshot() {
  //  const elementToCapture = document.getElementById('DivLineCanvas'); // Replace 'captureDiv' with the actual ID
  //  if (elementToCapture) {
  //    html2canvas(elementToCapture).then((canvas) => {
  //      // Convert the captured canvas to a data URL
  //      const imageDataUrl = canvas.toDataURL('image/png');

  //      // Create a temporary link element to download the image
  //      const a = document.createElement('a');
  //      a.href = imageDataUrl;
  //      a.download = 'screenshot.png';
  //      document.body.appendChild(a);
  //      a.click();
  //      document.body.removeChild(a);
  //    });
  //  }
  //}

  ///////////////////////////////////// End export file

  //// group
  LoadGroupBasedData() {
    this.selectedGroupID = [0];
    this.modelGrpCRName = "";

    this.controlCR.setValue("");
    this.selectedReportID = [0];
    this.selectedReportName = "";

    this.isBarChart = true;
    //groupReportList
    this.url = this.baseUrl + 'CustomReps/GetGroupReportList';

    this.GetCustomReportByFilterMethod_Service().subscribe((res: any) => {
      let rows: any[] = JSON.parse(res) as any[];

      this.groupReportList = this.FillDropDown(rows);//rows["groupReportsList"]
      this.getListGrpCR();

      if (rows.length > 0)
        this.selectedGroupID = [rows[0].ID];

      //console.log(this.restoreGroupID)
      if (this.restoreGroupID > 0 && this.isRefreshClicked) {
        this.selectedGroupID = [Number(localStorage.getItem('selectedGroupID'))];
        this.isRefreshClicked = false;
      }
      else if (this.firstTimeFunctionCall && this.restorePreviousReportID > 0 && !this.isRefreshClicked) {
        ///this condition is for first time to restore previuos selection after coming from another page
        this.firstTimeFunctionCall = false;
        this.selectedGroupID = [this.restorePreviousReportID];
        this.restorePreviousReportID = 0;///make it zero after assigning as it is for first time call after coming from another page
      }
      else
        this.firstTimeFunctionCall = false;

      localStorage.setItem('selectedGroupID', this.selectedGroupID[0].toString());///this is used when application refresh button is clicked.
      this.GetReportListByGroupName();
    },
      error => console.log('httperr', error));
  }

  GetReportListByGroupName() {
    if (this.selectedGroupID[0] > 0) {
      this.setLimitedOptionsGrpCR = true;
      this.grpCRNamesObservable = this.groupReportList;
    }
    let found = this.groupReportList.find(m => m.id == this.selectedGroupID[0]);
    let grpCritName = "";
    if (found)
      grpCritName = found.name;
    let grpName = grpCritName;
    localStorage.setItem('selectedGroupName', grpCritName);
    this.inputLengthGrpCR = grpName.length;
    this.controlGrpCR.setValue({ name: grpName });

    ///set selected custom reportid and selected  filter method[aggr/timestamp/group] in service so that to load selected custom report config details when configuration screen is opened
    this.commonFilterService.SetCustomReportID(this.selectedGroupID[0] + "@" + 'Group');

    // groupReportATList=rows["reportListByGroupName"];
    this.url = this.baseUrl + 'CustomReps/GetReportListByGroupName?groupName=' + grpName;

    this.GetCustomReportByFilterMethod_Service().subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];

      this.groupReportATMainList = rows;
      this.groupReportATList = this.FillDropDown(rows);//rows["groupReportsList"]
      if (rows.length > 0)
        this.selectedGroupATID = [rows[0].ID];
      this.GETCustomReportAT();

    },
      error => console.log('httperr', error));

  }

  GetReportListByGrpName(grpName) {
    this.url = this.baseUrl + 'CustomReps/GetReportListByGroupName?groupName=' + grpName;

    this.GetCustomReportByFilterMethod_Service().subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];
      if (rows.length > 0)
        this.selectedGroupID = [rows[0].ID];
      localStorage.setItem('selectedGroupID', this.selectedGroupID[0].toString());
      this.restoreGroupID = Number(localStorage.getItem('selectedGroupID'));
    },
      error => console.log('httperr', error));
  }

  GETCustomReportAT() {

    let CRName = "";
    let found = this.groupReportATMainList.find(m => m.ID == this.selectedGroupATID[0]);
    if (found) {
      CRName = found.Name;
      this.crFilterType = found.Value;
    }

    this.LoadCustomReport(CRName, true);
  }

  onddlChange(ddl, id, clearInput?) {

    switch (ddl) {
      case "Group":
        if (this.CRGrpClose) {
          this.CRGrpClose = false;
          break;
        }
        this.selectedGroupID = [id];
        localStorage.setItem('selectedGroupID', this.selectedGroupID[0].toString());///this is used when application refresh button is clicked.
        this.GetReportListByGroupName();
        if (this.myConfigNameGrpCR == "null")
          this.OpenAutoCompeleteDailogGrpCR(clearInput);
        break;
      case "GroupReportAT":
        this.selectedGroupATID = [id];
        this.GETCustomReportAT();
        break;
      case "TimestampSearch":
        this.selectedtimestampSearch = [id];
        this.timestampSearch = id;

        break;
      case "RecordPerPage":
        this.selectedRecordPerPage = [id];
        this.RecordPerPage = id;
        this.UpdateScreen();
        break;
    }
  }

  FillDropDown(data) {//, grpType: boolean) {
    let dll: SelectItem[] = [];
    //if (grpType)
    //  dll.push({ id: undefined, name: '--Select Reports Group--' });

    for (let i = 0; i < data.length; i++) {
      dll.push({ id: data[i].ID, name: data[i].Name });
    }
    return dll;
  }

  FillReportDropDown(data) {
    let dll: SelectItem[] = [];
    //dll.push({ id: undefined, name: '--Select Report--' });

    for (let i = 0; i < data.length; i++) {
      dll.push({ id: data[i].ID_Abs, name: data[i].CriteriaName_Abs });
    }
    return dll;
  }

  LoadReportByFilterMethod(filterMethod, isConfigPopupClosed?) {
    this.controlGrpCR.setValue("");
    this.selectedGroupID = [0];
    this.modelGrpCRName = "";

    //this.controlCR.setValue("");
    this.selectedReportID = [0];
    //this.selectedReportName = "";

    if (filterMethod.trim() == "Aggregate") {
      this.url = this.baseUrl + 'CustomReps/GetCustomReportByGroup';
    }
    else {
      this.url = this.baseUrl + 'CustomReps/GetCustomReportByNotGroup';
    }

    this.GetCustomReportByFilterMethod_Service().subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];

      this.reportList = rows["ReportList"];
      this.customReportList = this.FillReportDropDown(rows["ReportList"]);
      this.getListCR();

      //debugger
      if (isConfigPopupClosed) {
        //use prev selectedReportID
      }
      else {
        if (rows["ReportList"].length > 0)
          this.selectedReportID = [rows["ReportList"][0].ID_Abs];
      }

      ////if refresh is clicked then
      if (this.selectedReportName != "" && this.isRefreshClicked) {
        let selID = this.reportList.find(m => m.CriteriaName_Abs == this.selectedReportName).ID_Abs;
        this.selectedReportID = [selID];
        this.isRefreshClicked = false;
      }
      else if (this.firstTimeFunctionCall && this.restorePreviousReportID > 0 && !this.isRefreshClicked) {
        ///this condition is for first time to restore previuos selection after coming from another page
        this.firstTimeFunctionCall = false;
        this.selectedReportID = [this.restorePreviousReportID];
        this.restorePreviousReportID = 0;///make it zero after assigning as it is for first time call after coming from another page
      }
      else
        this.firstTimeFunctionCall = false;

      this.ChangeReportList(this.selectedReportID[0]);
    },
      error => console.log('httperr', error));
  }

  ChangeReportList(selectedReportID, clearInput?, event?: PageEvent) {
    //debugger

    if (this.CRClose) {
      this.CRClose = false;
      return;
    }
    this.isBarChart = true;
    this.isLineChart = false;
    if (selectedReportID != null) {
      this.setLimitedOptionsCR = true;
      this.CRNamesObservable = this.customReportList;
      //console.log(this.CRNamesObservable)
      this.selectedReportID = [selectedReportID];
      this.inputLengthCR = 1;
      this.reportID = selectedReportID;
      this.LoadCustomReport(this.selectedReportID[0], false, event);

      ///set selected custom reportid and selected  filter method[aggr/timestamp/group] in service so that to load selected custom report config details when configuration screen is opened
      this.commonFilterService.SetCustomReportID(selectedReportID + "@" + this.selectedFilter);
    }
    else {
      this.selectedReportID = [0];
      this.inputLengthCR = 0;
      if (this.myConfigNameCR == "null" && clearInput)
        this.OpenAutoCompeleteDailogCR(clearInput);
    }
  }

  async SetCustomFilters() {
    //if (this.MainFilterID != 0) {
    this.commonFilterService.DB_BRDiff.subscribe(res => {
      this.dbAndBrHrs = res;
    });
    if (this.dbAndBrHrs == -500) {//query var col table
      await this.service.getDBAndBrowserDiffHours('VquadData').then(res => {
        //debugger
        this.commonFilterService.setDBAndBrowserHrsDiff(res);
        this.dbAndBrHrs = res;
      });
    }
    //}

    //debugger - 2
    let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000), this.dbTz, this.dbAndBrHrs) + "^" + formatDate(new Date(), this.dbTz, this.dbAndBrHrs);//"06/02/2019 11:00:00^06/02/2019 20:00:00";  

    this.commonFilterService.TSBetween.subscribe(res => dates = res);//latest dates selected is set here from service
    //this.commonFilterService.TSRangeFilter.subscribe(res => { if (res.RangeType !== "custom") { dates = lastDateFunc(res.RangeType) } });//sets start and end dates to latest timestamps based on range type selection - IMP
    this.commonFilterService.TSRangeFilter.subscribe(res => {
      this.SetTimeFilter(res.RangeType)
      if (res.RangeType !== "custom") { dates = lastDateFunc(res.RangeType, this.dbTz, this.dbAndBrHrs) }
    });//sets start and end dates to latest timestamps based on range type selection - IMP
    //Save current date selection in service to affected when switched to other screens from here - IMP

    this.commonFilterService.setDatesProperties(dates);

    this.genArr.push({ ColumnName: this.timestampSearch, Operator: 6, Value: dates.split('^')[0], ValueTo: dates.split('^')[1], LoggedInUserName: null });

    //this.commonFilterService.TSRangeFilter.subscribe(res => { this.SetTimeFilter(res.RangeType) });//sets start and end dates to latest timestamps based on range type selection - IMP
  }

  SetTimestampSearch(tsSearch) {
    //{ id: 'VQUAD_TIMESTAMP', name: 'VQuad Timestamp' },
    //{ id: 'CALL_TIMESTAMP', name: 'Call Timestamp' },
    //{ id: 'DCOSS_TIMESTAMP', name: 'DCOSS Timestamp' },
    //{ id: 'VQT_Timestamp', name: 'VQT Timestamp' }

    this.commonFilter.TimestampType = tsSearch;
    switch (tsSearch) {
      case 0:
        this.timestampSearch = "CALL_TIMESTAMP";
        break;
      case 1:
        this.timestampSearch = "VQUAD_TIMESTAMP";
        break;
      case 2:
        this.timestampSearch = "VQT_Timestamp";
        break;
      case 3:
        this.timestampSearch = "DCOSS_TIMESTAMP";
        break;
    }

  }

  SetTimeFilter(timeFilter) {
    ////'year' | 'month' | 'day' | 'hour' | '7days' | '10min' | 'yesterday' | 'today' | 'custom' | '12hours';
    //{ id: '10min', name: '10 min' },
    //{ id: '1hr', name: '1 Hour' },
    //{ id: '12hr', name: '12 Hours' },
    //{ id: '24hr', name: '24 Hours' },
    //{ id: 'Today', name: 'Today' },
    //{ id: 'Yesterday', name: 'Yesterday' },
    //{ id: '7days', name: '7 Days' },
    //{ id: 'SearchEntiredBase', name: 'Search Entire dBase' },
    //{ id: 'Custom', name: 'Custom' }

    //alert(timeFilter);
    switch (timeFilter) {
      case "10min":
        this.timeFilter = "10min";
        break;
      case "hour":
        this.timeFilter = "1hr";
        break;
      case "12hours":
        this.timeFilter = "12hr";
        break;
      case "24hours":
        this.timeFilter = "24hr";
        break;
      case "today":
        this.timeFilter = "Today";
        break;
      case "yesterday":
        this.timeFilter = "Yesterday";
        break;
      case "7days":
        this.timeFilter = "7days";
        break;
      case "month":
        this.timeFilter = "Month";
        break;
      case "year":
        this.timeFilter = "Year";
        break;
      case "custom":
        /// 06/07/2021 10:39:47^06/23/2021 10:52:47     "07/27/2021 12:21:27"
        this.timeFilter = "Custom";
        this.commonFilterService.TSBetween.subscribe(res => {
          let custdate = res;
          if (this.selectedStartEndTime) {
            this.selectedStartEndTime.startDate = custdate.split('^')[0];
            this.selectedStartEndTime.endDate = custdate.split('^')[1];
          }
        });

        break;

    }
  }

  callUpdateScreenViaPaging(event?: PageEvent) {
    let myEvent: PageEvent;
    this.UpdateScreen(event).then(evt => { myEvent = evt; });
    return myEvent;
  }

  dbTz = -500;
  dbAndBrHrs = -500;
  AllGeneralFilter = [];
  filtersWithEventID = {};
  filters = {};
  delFilterColName = '';
  async UpdateScreen(event?: PageEvent) {
    //debugger

    //this.commonFilterService.ClearAllFilters.subscribe(res => { this.delFilterColName = 'clearAllFilters'; });

    //console.log(this.delFilterColName)
    if (this.delFilterColName == 'VQuad_CallID') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
    }
    else if (this.delFilterColName == 'clearAllFilters') {
      this.filtersWithEventID = {};
      for (const key in this.filters) {
        if (key.toUpperCase() !== this.timestampSearch.toUpperCase())
          delete this.filters[key];
      }
    }

    if (this.delFilterColName != 'clearAllFilters') {
      this.genArr = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"].toUpperCase() != this.timestampSearch.toUpperCase();
      });

      this.commonFilterService.GeneralFilterDF.subscribe(res => {
        //console.log(res)
        this.filters = res;
      });
    }

    if (typeof this.filtersWithEventID == 'object' && Object.keys(this.filtersWithEventID).length > 0) {
      this.dataFilter.filters = this.filtersWithEventID;
      //console.log(filtersWithEventID)
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != 'VQuad_CallID';
      });
      let generalFilterArrayAll = this.dataFilter.getProcessedFiltersArray("ALL");
      this.genArr = [...this.genArr, ...generalFilterArrayAll];

      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }
      let generalFilterArrayNew = this.dataFilter.getProcessedFilters("");
      this.filters = { ...this.filters, ...generalFilterArrayNew };
    }
    else if (Object.keys(this.filtersWithEventID).length == 0) {
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != 'VQuad_CallID';
      });

      for (const key in this.filters) {
        if (key == 'VQuad_CallID')
          delete this.filters[key];
      }

    }
    //console.log(this.genArr)
    //console.log(filters)

    if (this.delFilterColName != '' && this.delFilterColName != 'clearAllFilters') {
      //cleared = 1;
      this.genArr = this.genArr.filter(el => {
        return el["ColumnName"] != this.delFilterColName;
      });

      for (const key in this.filters) {
        if (key == this.delFilterColName)
          delete this.filters[key];
      }
    }
    //console.log(this.genArr)
    this.hasFilters = this.genArr.length <= 0 ? false : true;

    if (this.delFilterColName != 'clearAllFilters') {
      //let newFilters = {};
      //for (const key in this.filters) {
      //  if (this.filters[key].rsltType == 'call-events' || this.filters[key].rsltType == '') {
      //    let value = this.filters[key].value;
      //    let matchMode = this.filters[key].matchMode;
      //    let valueTo = this.filters[key].valueTo;
      //    let type = this.filters[key].type;
      //    let rsltType = this.filters[key].rsltType;
      //    let title = this.filters[key].title;
      //    newFilters[key] = { value, matchMode, valueTo, type, rsltType, title };
      //  }
      //}
      ////console.log(newFilters)
      this.commonFilterService.setGeneralFilterData(this.filters);//(newFilters);
    }
    else
      this.hasFilters = false;


    if (!this.hasFilters) {
      ///if clearfilter is clicked then remove all filters from this.genArr
      //debugger;
      this.genArr = [];
    }
    //this.commonFilterService.DB_TZ.subscribe(res => {
    //  dbTz = res;
    //});
    //if (dbTz == -500) {//query var col table
    //  await this.service.getDBTimezoneDiff('VquadData').then(res => {
    //    this.commonFilterService.setDBTZFromVarCol(res);
    //    dbTz = res;
    //  });
    //}
    ////console.log(dbTz)


    //debugger;
    //this.commonFilterService.mfTZ.subscribe(res => this.MainFilterTZ = res);
    //if (this.MainFilterTZ == 0) {
    //  this.commonFilterService.setDBAndBrowserHrsDiff(-500);
    //}



    ////debugger;
    //await this.SetCustomFilters();

    //this.commonFilter = new CommonFilter();
    //this.commonFilterService.TSType.subscribe(res => this.commonFilter.TimestampType = res);//TsType
    //alert(this.commonFilter.TimestampType);
    //this.commonFilterService.TSBetween.subscribe(res => alert(res));//latest dates selected is set here from service
    /////if (res.RangeType !== "custom") 
    //this.commonFilterService.TSRangeFilter.subscribe(res => { this.SetTimeFilter(res.RangeType) });//sets start and end dates to latest timestamps based on range type selection - IMP

    // return;

    this.isLineChart = false;
    if ((this.selectedFilter !== "Group" && this.selectedReportID[0] == 0) || (this.selectedFilter == "Group" && this.selectedGroupATID[0] == 0)) {
      //alert("Please select report.");
      return;
    }

    //debugger
    let group = false;
    if (this.selectedFilter == "Group") {
      group = true;
      let CRName = this.groupReportATMainList.find(m => m.ID == this.selectedGroupATID[0]).Name;
      this.LoadCustomReport(CRName, group, event);
    }
    else
      this.LoadCustomReport(this.selectedReportID[0], group, event);

    if (this.delFilterColName != '' && this.delFilterColName != 'clearAllFilters') {
      this.delColSelected = true;

      this.commonFilterService.setDeleteFilterData('');//reset if delete

      if (this.delFilterColName == 'VQuad_CallID') {
        this.commonFilterService.setGeneralEventIDFilterData({});
      }

      this.genArrDel = this.AllGeneralFilter.filter(el => {
        return el["ColumnName"] != this.delFilterColName;
      });
      //console.log(this.genArrDel)
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    else if (this.delFilterColName == 'clearAllFilters') {
      this.clearAllFiltersBool = true;

      this.commonFilterService.setClearAllFiltersData();//reset if delete
      this.commonFilterService.setGeneralFilterData(this.filters);

      this.filtersWithEventID = {};
      this.commonFilterService.setGeneralEventIDFilterData({});

      this.genArrDel = [];
      this.commonFilterService.setAllGeneralFilterData(this.genArrDel);
    }
    //debugger

    return event;
  }

  CheckCustomDate(timeFilterOption) {
    this.selectedtimeFilter = [timeFilterOption];
    this.timeFilter = timeFilterOption;

    if (timeFilterOption == "Custom")
      this.isCustomDate = true;
    else
      this.isCustomDate = false;
  }

  ///////////// Bar Chart

  GetDataset(rows) {
    let dataset: any[] = [];

    for (let i = 0; i < rows.ChartData.Dataset.length; i++) {
      dataset.push({
        label: rows.ChartData.Dataset[i].Legend,//"Europe",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
        type: "bar",
        //backgroundColor: this.RandomColorCode(),
        backgroundColor: this.colorCodes[i],
        data: rows.ChartData.Dataset[i].Data

      });
    }
    //console.log(dataset)
    return dataset;
  }

  BindBarChart(rows, reportName) {
    //console.log(rows.ChartData);
    this.isBarChart = true;
    if (rows.ChartData != null) {
      //if (rows.ChartData.Labels.length > 0) {
      if (rows.ChartData.Labels.length > 0) {
        this.isBarChart = true;
        this.cdr.detectChanges();

        /////// https://stackoverflow.com/questions/24815851/how-to-clear-a-chart-from-a-canvas-so-that-hover-events-cannot-be-triggered
        //if (document.getElementById("DivBarCanvas") != null) {
        //  document.getElementById("DivBarCanvas").innerHTML = '&nbsp;';
        //  document.getElementById("DivBarCanvas").innerHTML = '<div style="margin-left:270px"> </div>';
        //  document.getElementById("DivBarCanvas").innerHTML = '<canvas id="canvas"></canvas>';
        //}

        // destroy bar chart if already exist //  != undefined
        if (this.barChart != null)
          this.barChart.destroy();
        
        if (document.getElementById("canvas") != null) {
          this.barChart = new Chart((<HTMLCanvasElement>document.getElementById("canvas")).getContext("2d"), {
            type: "bar",
            data: {
              labels: rows.ChartData.Labels,// ["Red1", "blue", "orange", "green"], ////label is no of groupname fetched from data result // rows.ChartData.Labels
              datasets: this.GetDataset(rows),
              //datasets: [ ///dataset is no of column selected as bar from config screen
              //  {
              //    label: "Europe",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
              //    type: "bar",
              //    backgroundColor: this.RandomColorCode(),
              //    backgroundColorHover: "#3e95cd",
              //    data: [408, 547, 675, 734],///data is selected column value //rows.ChartData.Dataset[0].Data
              //  },
              //]
            },
            options: {
              scales: {
                yAxes: [
                  {
                    minBarLength: 3,
                    ticks: {
                      beginAtZero: true,
                      suggestedMin: 0,
                    }
                  }
                ]
              }
            }
          });

          this.barChart.render();
          this.dummyBarChart = this.barChart;
          //this.GetLineGraphDataList(reportName);///line graph
        }
      }
      else {
        ///////////to show empty graph if od data is found for the configured graph
        this.isBarChart = true;
        this.cdr.detectChanges();

        //if (document.getElementById("DivBarCanvas") != null) {
        //  document.getElementById("DivBarCanvas").innerHTML = '&nbsp;';
        //  document.getElementById("DivBarCanvas").innerHTML = '<div style="margin-left:270px"> </div>';
        //  document.getElementById("DivBarCanvas").innerHTML = '<canvas id="canvas"></canvas>';
        //}
        if (this.barChart != null)
          this.barChart.destroy();

        if (document.getElementById("canvas") != null) {
          this.barChart = new Chart((<HTMLCanvasElement>document.getElementById("canvas")).getContext("2d"), {
            type: "bar",
            data: {
              labels: [],// ["Red1", "blue", "orange", "green"], ////label is no of groupname fetched from data result // rows.ChartData.Labels
              //datasets: this.GetDataset(rows),
              datasets: [ ///dataset is no of column selected as bar from config screen
                {
                  label: "No Data Found",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend                              
                  data: [],///data is selected column value //rows.ChartData.Dataset[0].Data
                },
              ]
            },
            options: {
              scales: {
                yAxes: [
                  {
                    position: 'left',
                    ticks: {
                      precision: 0,
                      beginAtZero: true,
                      // display: false
                    }
                  }
                ],
              }
            }
          });

          this.barChart.render();
          //this.dummyBarChart = this.barChart;
        }
      }
    }
    else
      this.isBarChart = false;
  }

  //NOT IN USE
  BindBarChartTest() {
    //this.isBarChart = true;
    this.barChart1 = new Chart((<HTMLCanvasElement>document.getElementById("dummycanvas")).getContext("2d"), {
      type: "bar",
      data: {
        labels: [], ////label is no of groupname fetched from data result // rows.ChartData.Labels
        datasets: [ ///dataset is no of column selected as bar from config screen
          {
            label: "No Data Found",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
            type: "bar",
            // backgroundColor: "rgba(151,187,205,1)",

            data: [],///data is selected column value //rows.ChartData.Dataset[0].Data
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {

              position: 'left',
              ticks: {
                precision: 0,
                beginAtZero: true,
                // display: false
              }
            }
          ],

        }
      }
    });
  }

  RandomColorCode() {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    return "#" + randomColor;
  }


  //NOT IN USE
  BindBarChartSample() {

    this.barChart1 = new Chart((<HTMLCanvasElement>document.getElementById("dummycanvas")).getContext("2d"), {
      type: 'bar',
      data: {
        labels: ['Accepted Answer', 'Top rated answer', 'This Answer'],
        datasets: [{
          data: [0, 40, 100],    // This is the important line!
          backgroundColor: 'blue',
          borderWidth: 5
        }]
      },
      options: {
        title: {
          display: true,
          text: 'helpfulness of answers to this questions'
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              minBarLength: 3,
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    });
  }

  //////////// Line Chart - NOT IN USE
  GetLineGraphDataList(reportName) {

    let startDate = "";
    let endDate = "";

    if (this.timeFilter == "Custom") {
      startDate = this.startDate.toDateString();
      endDate = this.endDate.toDateString();
    }

    if (this.selectedFilter.trim() == "Aggregate")
      this.url = this.baseUrl + 'CustomReps/GetCustomReportGroupMainScreenData_LineGragh?reportName=' + reportName + '&timeFilter=' + this.timeFilter + '&timestampSearch=' + this.timestampSearch + '&startDate=' + startDate + '&endDate=' + endDate;
    else if (this.selectedFilter == "Timestamp")
      this.url = this.baseUrl + 'CustomReps/GetCustomReportNGpMainScreenData_LineGragh?reportName=' + reportName + '&timeFilter=' + this.timeFilter + '&timestampSearch=' + this.timestampSearch + '&startDate=' + startDate + '&endDate=' + endDate;
    else {
      if (this.crFilterType.trim() == "Aggregate")
        this.url = this.baseUrl + 'CustomReps/GetCustomReportGroupMainScreenData_LineGragh?reportName=' + reportName + '&timeFilter=' + this.timeFilter + '&timestampSearch=' + this.timestampSearch + '&startDate=' + startDate + '&endDate=' + endDate;
      else
        this.url = this.baseUrl + 'CustomReps/GetCustomReportNGpMainScreenData_LineGragh?reportName=' + reportName + '&timeFilter=' + this.timeFilter + '&timestampSearch=' + this.timestampSearch + '&startDate=' + startDate + '&endDate=' + endDate;
    }
    //console.log(this.genArr)
    let body = JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.genArr });
    this.GetCustomReport_Service(body).subscribe((res: any) => {
      //console.log(res);
      let rows: any[] = JSON.parse(res) as any[];
      //debugger;

      this.BindLineChart(rows); //bind line chart

    },
      error => console.log('httperr', error));
  }

  GetDatasetData(rows) {
    let data: any[] = [];
    for (let x = 0; x < rows.length; x++) {
      data.push(rows[x].Data);
    }
    return data;
  }
  GetLineGraphDataset(rows) {
    let dataset: any[] = [];
    //debugger;
    //for (let i = 0; i < rows.LineChartData.Dataset.length; i++) {
    //  data.push(rows.LineChartData.Dataset[i].Data);
    //}

    for (let k = 0; k < rows.length; k++) {
      dataset.push({
        label: rows[k].Dataset[0].Legend,//"Europe",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend 
        backgroundColor: this.RandomColorCode(),
        backgroundColorHover: "#3e95cd",
        borderColor: this.RandomColorCode(),
        data: this.GetDatasetData(rows[k].Dataset), //rows.LineChartData.Dataset[i].Data,
        lineTension: 0.2,
        borderWidth: 1,
        pointStyle: "line",
        fill: false,
      });
    }

    return dataset;
  }
  BindLineChart(rows) {
    //debugger;
    //console.log(rows)
    this.isLineChart = false;
    if (rows.LineChartData != null) {
      if (rows.LineChartData.length > 0) {
        this.filterType_LineGraph = this.selectedFilter != "Group" ? this.selectedFilter : this.crFilterType;
        this.isLineChart = true;
        this.lineChartCount = Array(rows.LineChartData.length).fill(0).map((x, i) => i);
        this.lineChartData = rows.LineChartData;

        let timeFormat = 'HH:mm:ss';
        let colonCnt = -1;
        let eiphenCnt = -1;
        this.lineChartData.forEach(eachData => {
          Object.keys(eachData).forEach(key => {
            if (key) {
              eachData[key].Labels.forEach((value, i) => {
                if (i == 0) {
                  colonCnt = value.split(":").length - 1;
                  if (colonCnt == 1)
                    timeFormat = 'HH:mm';
                  else if (colonCnt == 0)
                    timeFormat = 'HH:mm';//'HH'
                  eiphenCnt = value.split("-").length - 1;
                }
                //eachData[key].Labels[i] = ((value.indexOf('-') == -1 && value.indexOf(':') == -1) || eiphenCnt == 1) ? value.replace(/\-/g, '/') : this.datepipe.transform(new Date(formatDBTZDateToLocalDate(value.replace(/\-/g, '/'), this.dbTz, this.dbAndBrHrs, this.MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat);//this.datepipe.transform(new Date(formatDBTZDateToLocalDate(getDateValueViaValue(value, ' '), this.dbTz, this.dbAndBrHrs, this.MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat);
                eachData[key].Labels[i] = ((value.indexOf('-') == -1 && value.indexOf(':') == -1) || eiphenCnt == 1) ? new Date(value.replace(/\-/g, '/')) : new Date(this.datepipe.transform(new Date(formatDBTZDateToLocalDate(value.replace(/\-/g, '/'), this.dbTz, this.dbAndBrHrs, this.MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat));//this.datepipe.transform(new Date(formatDBTZDateToLocalDate(getDateValueViaValue(value, ' '), this.dbTz, this.dbAndBrHrs, this.MainFilterTZ)), 'MM/dd/yyyy ' + timeFormat);
              })
            }
          });
        });
        //console.log(this.lineChartData)
      }
    }
  }

  // This method gets called when the chart instance is emitted by the child component
  onChartCreated(chart: Chart) {
    this.mlineChart.push(chart);
    //console.log('Chart instance received:', this.mlineChart);
  }


  //NOT IN USE
  BindMultiLineChartTest() {
    this.chartID = "0";

    //// 
    this.lineChartTest = new Chart((<HTMLCanvasElement>document.getElementById("canvas2")).getContext("2d"), {
      type: "line",
      data: {
        labels: ["Jan", "Feb", "March", "April", "May", "June", "July", "August"], ////label is no of groupname fetched from data result // rows.ChartData.Labels        
        datasets: [ ///dataset is no of column selected as bar from config screen
          {
            label: "A",/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
            fill: false,
            //interval: 2,
            yAxisID: 'A',
            backgroundColor: this.RandomColorCode(),
            backgroundColorHover: this.RandomColorCode(),
            borderColor: this.RandomColorCode(),
            data: [100, 150, 200, 250, 300, 350, 400, 450],///data is selected column value //rows.ChartData.Dataset[0].Data
            lineTension: 0.1,
            borderWidth: 1,
            pointStyle: "line"
          },
          {
            label: 'B',
            yAxisID: 'B',
            fill: false,
            data: [1, 1, 1, 1, 0, 2, 3, 4],
            lineTension: 0.1,
            borderWidth: 1,
            pointStyle: "line"
          }

        ]
      },
      options: {
        responsive: true,
        scales: {
          yAxes: [
            {
              id: 'A',
              type: 'linear',
              position: 'left',
              ticks: {
                beginAtZero: true
              }
            },
            {
              id: 'B',
              type: 'linear',
              position: 'right',
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        // Container for pan options
        pan: {
          // Boolean to enable panning
          enabled: true,

          // Panning directions. Remove the appropriate direction to disable 
          // Eg. 'y' would only allow panning in the y direction
          mode: 'xy'
        },

        // Container for zoom options
        zoom: {
          // Boolean to enable zooming
          enabled: false,

          // Zooming directions. Remove the appropriate direction to disable 
          // Eg. 'y' would only allow zooming in the y direction
          mode: 'xy',
        },
        bezierCurve: false
      }
    });


  }
  //NOT IN USE
  BindLineChart1(rows) {
    //debugger;/////hard code line chart
    this.isLineChart = false;
    if (rows.LineChartData != null && rows.LineChartData.length > 0) {
      this.isLineChart = true;

      for (let i = 0; i < rows.LineChartData.length; i++) {
        this.chartID = "";
        this.chartID = i.toString();
        this.lineChart = new Chart((<HTMLCanvasElement>document.getElementById(this.chartID)).getContext("2d"), {
          type: "line",
          data: {
            labels: rows.LineChartData[i][0].Labels,//rows.LineChartData.Labels, ////label is no of groupname fetched from data result // rows.ChartData.Labels
            datasets: this.GetLineGraphDataset(rows.LineChartData[i]),
            //datasets: [ ///dataset is no of column selected as bar from config screen
            //  {
            //    label: rows.LineChartData.Dataset[0].Legend,/// label is coloumn Name //rows.ChartData.Dataset[0].Legend
            //    fill: false,
            //    backgroundColor: this.RandomColorCode(),
            //    backgroundColorHover: "#3e95cd",
            //    data:this.GetLineGraphDataset(rows),  //[1, 4, 2, 2, 5, 6, 7, 4, 3, 2, 1, 3, 4, 0, 7,],///data is selected column value //rows.ChartData.Dataset[0].Data
            //    lineTension: 0.1,
            //    borderWidth: 1,
            //    pointStyle: "line"
            //  } 
            //]
          },
          options: {
            responsive: true,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
            },
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: true,

              // Panning directions. Remove the appropriate direction to disable 
              // Eg. 'y' would only allow panning in the y direction
              mode: 'xy'
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable 
              // Eg. 'y' would only allow zooming in the y direction
              mode: 'xy',
            },
            bezierCurve: false
          }
        });
        // }
        this.mlineChart.push(this.lineChart);
      }
    }

  }

  /////////////////////////////////////// SERVICE CALL
  GetCustomReport_Service(body) {
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    return this.http.post<any>(this.url, body, options);
  }

  GetCustomReportByFilterMethod_Service() {
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);
  }

  ExportReportToPDF_Service() {
    //debugger;
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    let reportName = this.selectedFilter != "Group" ? this.reportList.find(m => m.ID_Abs == this.selectedReportID[0]).CriteriaName_Abs : this.groupReportList.find(m => m.id == this.selectedGroupID[0]).name;
    let webviewJob: Job = new Job();

    let selectedMainFilterCrieriaName = '';
    this.commonFilterService.mainFilter_CriteriaName.subscribe(res => selectedMainFilterCrieriaName = res);// set mainfilter ID
    webviewJob.FilterFromDB = selectedMainFilterCrieriaName;
    //debugger;

    /////check if selected mainfilter has timezone else set dbAndBrHrs to default value -500
    //console.log(this.MainFilterTZ)
    //this.commonFilterService.mfTZ.subscribe(res => this.MainFilterTZ = res);
    if (this.MainFilterTZ == 0) {
      this.commonFilterService.setDBAndBrowserHrsDiff(-500);
    }
    this.commonFilterService.DB_BRDiff.subscribe(res => {
      this.dbAndBrHrs = res;
    });
    webviewJob.DB_BRDiff = this.dbAndBrHrs.toString();

    webviewJob.Title = reportName;
    webviewJob.CRName = reportName;
    webviewJob.ifToBeRecurred = 0;
    webviewJob.TimestampTypeFilter = this.GetFormatedTimesstampSearch(this.timestampSearch);
    webviewJob.TimeDiffFilter = this.timeFilter;

    //webviewJob.WebviewConfigUpdated = 0;
    //if (this.customReportList.length <= 1)
    //  webviewJob.WebviewConfigUpdated = 1;

    webviewJob.DataImportOrWebview = 0;
    if (this.timeFilter == "Custom") {
      //webviewJob.startTimestampFilter = this.selectedStartEndTime.startDate.format('MM/DD/YYYY HH:mm:ss'); //this.startDate.toDateString();
      //webviewJob.endTimestampFilter = this.selectedStartEndTime.endDate.format('MM/DD/YYYY HH:mm:ss'); //this.endDate.toDateString();
      webviewJob.startTimestampFilter = this.selectedStartEndTime.startDate;
      webviewJob.endTimestampFilter = this.selectedStartEndTime.endDate;
    }

    //if (this.selectedReportID[0] > 0) {
    if (this.selectedFilter != "Group") {
      webviewJob.CRName = reportName;//this.selectedReportID[0].toString();
      webviewJob.CRGroupOrNot = this.selectedFilter.trim() == "Aggregate" ? "" : "Not";
    }
    else {
      // webviewJob.CRGroupOrNot = this.selectedGroupID[0].toString();
      webviewJob.CRGroupOrNot = "GROUP";
    }
    webviewJob.generalFilterArray = this.genArr;
    //console.log(webviewJob)
    //console.log(this.genArr)
    return this.http.post<any>(this.url, '{"webviewJob" : ' + JSON.stringify(webviewJob) + '}', options);
  }




  displayFnCR(selectItem: SelectItem): string {
    return selectItem && selectItem.name && !selectItem.name.includes('--Select Custom Report--') ? selectItem.name : '';
  }

  _CRName(value: any): SelectItem[] {
    let CRNameValue = '';
    if (typeof value === "string") {
      this.toHighlightCR = value;
      CRNameValue = value.toLowerCase();
    }
    else {
      this.toHighlightCR = value.name;
      CRNameValue = value.name.toLowerCase();
    }
    return this.customReportList.filter(option => option.name.toLowerCase().includes(CRNameValue) || option.name.includes('--Select Custom Report--'));
  }

  getListCR() {
    this.CRNamesObservable = this.customReportList;

    if (this.myConfigNameCR != "null" && this.initCR)
      this.setConfigByNameCR(this.myConfigNameCR);
  }
  setConfigByNameCR(name) {
    this.selectedReportName = name;
    //this.ResetPage();
    //console.log(this.selectedReportName)
    let CRConfigName = this.selectedReportName.trim();
    //this.resetCritErrors();
    if (CRConfigName.length == 0) {
      this.ChangeReportList(null);
      return;
    }
    let found = this.customReportList.find(x => x.name == CRConfigName);
    if (found) {
      let id = found.id;
      this.ChangeReportList(id);
    }

    this.initCR = false;
  }

  inputLengthCR = 0;
  setLimitedOptionsCR = true;
  onKeydownMainCR($event) {
    if (!this.setLimitedOptionsCR) {
      this.setLimitedOptionsCR = true;
      this.controlCR.valueChanges.subscribe(newValue => {
        this.CRNamesObservable = this._CRName(newValue);
      })
    }

    this.inputLengthCR = $event.target.value.length;
    this.selectedReportName = $event.target.value;
    if (this.inputLengthCR == 0) {
      this.controlCR.setValue("");
      this.triggerCollection.forEach((x, i) => {
        if (i == 0) {
          let firstSelectedOption = x.autocomplete.options.find(o => o.value.id == this.selectedReportID[0]);
          if (firstSelectedOption) {
            this.CRClose = true;
            this.controlCR.setValue("");
            firstSelectedOption.deselect();
          }
        }
      });
    }
  }
  clearInputTextCR() {
    this.controlCR.setValue("");
    this.inputLengthCR = 0;
  }
  clearInputCR(auto: MatAutocomplete) {
    this.controlCR.setValue("");
    this.inputLengthCR = 0;
    this.selectedReportID = [0];
    this.selectedReportName = "";
    //input.placeholder = '';
    //input.value = '';
    //auto.options.forEach(option => option.deselect());
    //auto.closePanel();
    this.ChangeReportList(null, false);
    //if (this.myConfigNameCR != "null") {
    //  this.triggerCollection.forEach((x, i) => {
    //    if (i == 0)
    //      setTimeout(() => x.openPanel());
    //  });
    //}
  }

  openOrCloseCR = false;
  CRClose = false;
  OpenAutoCompeleteDailogCR(init?, closed?) {
    //const input = document.getElementById('message') as HTMLInputElement;
    //input.focus();
    let tmOut = 0;
    if (init)
      tmOut = 1000;
    else {
      this.setLimitedOptionsCR = false;
      this.CRNamesObservable = this.customReportList;
    }
    //console.log(init)
    //console.log(this.inputLengthCR)

    this.triggerCollection.forEach((x, i) => {
      if (i == 0) {
        if (this.openOrCloseCR == true || closed) {
          setTimeout(() => x.closePanel());
          this.openOrCloseCR = false;
        }
        else {
          setTimeout(() => {
            this.inputCtrl.nativeElement.blur();
            this.inputCtrl.nativeElement.focus();
            this.toHighlightCR = this.inputCtrl.nativeElement.value;
            if (this.inputLengthCR > 0) {
              let firstSelectedOption = x.autocomplete.options.find(o => o.selected);
              if (firstSelectedOption === undefined && this.selectedReportID.length > 0) {
                firstSelectedOption = x.autocomplete.options.find(o => o.value.id == this.selectedReportID[0]);
                if (firstSelectedOption) {
                  if (this.initArrow)
                    this.CRClose = true;
                  firstSelectedOption.select();
                  setTimeout(() => {
                    x.openPanel();
                    firstSelectedOption._getHostElement().scrollIntoView({
                      block: 'center',
                    });
                  });
                }
              }
              if (firstSelectedOption) {
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              }
            }
            //x.openPanel();
          }, tmOut);
          this.openOrCloseCR = true;
        }
      }
    });
  }

  initArrow = true;
  SetArrowClick() {
    if (this.initArrow) {
      this.initArrow = false;
    }
  }





  displayFnGrpCR(selectItem: any): string {
    return selectItem && selectItem.name && !selectItem.name.includes('--Select Reports Group--') ? selectItem.name : '';
  }

  _GrpCRName(value: any): any[] {
    let GrpCRNameValue = '';
    if (typeof value === "string") {
      this.toHighlightGrpCR = value;
      GrpCRNameValue = value.toLowerCase();
    }
    else {
      this.toHighlightGrpCR = value.name;
      GrpCRNameValue = value.name.toLowerCase();
    }
    return this.groupReportList.filter(option => option.name.toLowerCase().includes(GrpCRNameValue) || option.name.includes('--Select Reports Group--'));
  }

  getListGrpCR() {
    this.grpCRNamesObservable = this.groupReportList;

    if (this.myConfigNameGrpCR != "null" && this.initGrpCR)
      this.setConfigByNameGrpCR(this.myConfigNameGrpCR);
  }
  setConfigByNameGrpCR(name) {
    this.modelGrpCRName = name;
    //this.ResetPage();
    //console.log(this.modelGrpCRName)
    let GrpCRConfigName = this.modelGrpCRName.trim();
    //this.resetCritErrors();
    if (GrpCRConfigName.length == 0) {
      this.onddlChange("Group", 0, false);
      return;
    }

    let found = this.groupReportList.find(x => x.name == GrpCRConfigName);
    if (found) {
      let id = found.id;
      this.onddlChange("Group", id, false);
    }

    this.initGrpCR = false;
  }

  inputLengthGrpCR = 0;
  setLimitedOptionsGrpCR = true;
  onKeydownMainGrpCR($event) {
    if (!this.setLimitedOptionsGrpCR) {
      this.setLimitedOptionsGrpCR = true;
      this.controlGrpCR.valueChanges.subscribe(newValue => {
        this.grpCRNamesObservable = this._GrpCRName(newValue);
      })
    }
    this.inputLengthGrpCR = $event.target.value.length;
    this.modelGrpCRName = $event.target.value;
    if (this.inputLengthGrpCR == 0) {
      this.controlGrpCR.setValue("");
      this.triggerCollection.forEach((x, i) => {
        if (i == 0) {
          let firstSelectedOption = x.autocomplete.options.find(o => o.value.id == this.selectedGroupID[0]);
          if (firstSelectedOption) {
            this.CRGrpClose = true;
            this.controlGrpCR.setValue("");
            firstSelectedOption.deselect();
          }
        }
      });
    }
  }
  clearInputTextGrpCR() {
    this.controlGrpCR.setValue("");
    this.inputLengthGrpCR = 0;
  }
  clearInputGrpCR(auto: MatAutocomplete) {
    this.controlGrpCR.setValue("");
    this.inputLengthGrpCR = 0;
    this.selectedGroupID = [0];
    this.modelGrpCRName = "";
    //input.placeholder = '';
    //input.value = '';
    //auto.options.forEach(option => option.deselect());
    //auto.closePanel();
    this.onddlChange("Group", 0, false);
    //if (this.myConfigNameGrpCR != "null") {
    //  this.triggerCollection.forEach((x, i) => {
    //    if (i == 0)
    //      setTimeout(() => x.openPanel());
    //  });
    //}
  }

  openOrCloseGrpCR = false;
  CRGrpClose = false;
  OpenAutoCompeleteDailogGrpCR(init?, closed?) {
    //const input = document.getElementById('message') as HTMLInputElement;
    //input.focus();
    let tmOut = 0;
    if (init)
      tmOut = 1000;
    else {
      this.setLimitedOptionsGrpCR = false;
      this.grpCRNamesObservable = this.groupReportList;
    }

    this.triggerCollection.forEach((x, i) => {
      if (i == 0) {
        if (this.openOrCloseGrpCR == true || closed) {
          setTimeout(() => x.closePanel());
          this.openOrCloseGrpCR = false;
        }
        else {
          setTimeout(() => {
            this.inputGrpCtrl.nativeElement.blur();
            this.inputGrpCtrl.nativeElement.focus();
            this.toHighlightGrpCR = this.inputGrpCtrl.nativeElement.value;
            if (this.inputLengthGrpCR > 0) {
              let firstSelectedOption = x.autocomplete.options.find(o => o.selected);
              if (firstSelectedOption === undefined && this.selectedGroupID.length > 0) {
                firstSelectedOption = x.autocomplete.options.find(o => o.value.id == this.selectedGroupID[0]);
                if (firstSelectedOption) {
                  if (this.initArrowGrp)
                    this.CRGrpClose = true;
                  firstSelectedOption.select();
                  setTimeout(() => {
                    x.openPanel();
                    firstSelectedOption._getHostElement().scrollIntoView({
                      block: 'center',
                    });
                  });
                }
              }
              if (firstSelectedOption) {
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              }
            }
            //x.openPanel();
          }, tmOut);
          this.openOrCloseGrpCR = true;
        }
      }
    });
  }

  initArrowGrp = true;
  SetArrowClickGrp() {
    if (this.initArrowGrp) {
      this.initArrowGrp = false;
    }
  }

  //////////////////////////////// Default Initial Values
  colorCodes: string[] = [
    //"#FF0000",
    //"#EE9ED9",    
    //"#55FF55",
    //"#55AAFF",
    //"#C54F00",
    "#A1D0D8", "#8EB848", "#193E4E", "#FF0000", "#FFFF00", "#008000"
  ];

  timeFilterList: SelectItem[] = [
    { id: '10min', name: '10 min' },
    { id: '1hr', name: '1 Hour' },
    { id: '12hr', name: '12 Hours' },
    { id: '24hr', name: '24 Hours' },
    { id: 'Today', name: 'Today' },
    { id: 'Yesterday', name: 'Yesterday' },
    { id: '7days', name: '7 Days' },
    { id: 'SearchEntiredBase', name: 'Search Entire dBase' },
    { id: 'Custom', name: 'Custom' }
  ];

  timestampSearchList: SelectItem[] = [
    { id: 'VQUAD_TIMESTAMP', name: 'VQuad Timestamp' },
    { id: 'CALL_TIMESTAMP', name: 'Call Timestamp' },
    { id: 'DCOSS_TIMESTAMP', name: 'DCOSS Timestamp' },
    { id: 'VQT_Timestamp', name: 'VQT Timestamp' }
  ];

  RecordPerPageList: SelectItem[] = [
    { id: '20', name: '20' },
    { id: '50', name: '50' },
    { id: '100', name: '100' },
    { id: '200', name: '200' },
    { id: '300', name: '300' },
    { id: '500', name: '500' }
  ];

}
